import {
  IClearCampaignModeAction,
  ISetCampaignModeAvailableTpTmCodesAction,
  ISetCampaignModeRecommendedTpTmCodeAction,
  ISetCampaignModeStatusAction,
  ISetCampaignOreSubmitDataAction
} from "./types";
import ActionTypes from "../../../../constants/ActionTypes";
import { IProduct } from "../../../../entities/product/types";
import OreOffer from "../../../../entities/campaigns/offers/OreOffer";

export function setCampaignModeStatus(status: boolean): ISetCampaignModeStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_STATUS,
    payload: status,
  };
}

export function setCampaignModeRecommendedTpTmCodeAction(tmCode: number): ISetCampaignModeRecommendedTpTmCodeAction {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_RECOMMENDED_TP_TMCODE,
    payload: tmCode,
  };
}

export function setCampaignModeAvailableTpTmCodesAction(tmCodes: number[]): ISetCampaignModeAvailableTpTmCodesAction {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_AVAILABLE_TP_TMCODES,
    payload: tmCodes,
  };
}

export function setCampaignOreSubmitDataAction(product: IProduct, oreOffer: OreOffer, channel: string): ISetCampaignOreSubmitDataAction {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_ORE_SUBMIT_DATA,
    payload: {
      product,
      oreOffer,
      channel
    },
  };
}

export function getOreSubmitDataFromBackup(productId: number) {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.GET_ORE_SUBMIT_DATA_FROM_BACKUP,
    payload: productId
  };
}

export function clearCampaignModeAction(): IClearCampaignModeAction {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.CLEAR_CAMPAIGN_MODE,
    payload: null,
  };
}

export function checkForOreSubmitData(productId: number) {
  return {
    type: ActionTypes.CAMPAIGN.CAMPAIGN_MODE.CHECK_FOR_ORE_SUBMIT_DATA,
    payload: productId
  };
}

